
































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Tree } from 'element-ui';
import ToolBox from '@/components/common/ToolBox.vue';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { EnumComponentType } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
import { BEEntity } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { BEServiceAction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { ProductComment } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductComment';
import { APPComment } from '@/api/com/MetaPattern/MDA/MD/APPModel/APPComment';
import { BEComment } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComment';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import { BEEnum } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { BEBusinessLogic } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { BEDTO } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { BEValueObject } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { BEService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEService';
import { BEConstant } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { BEDistributedTransaction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { BEExternalService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { BEReferenceEntity } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEReferenceEntity';
import { EntityMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EntityMethod';
import { MenuSet } from '@/api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { ConfigGroup } from '@/api/com/MetaPattern/MDA/MD/APPModel/ConfigGroup';
import { ProductAPP } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductAPP';
import { BEInterface } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { DesignerExtendService } from '@/libs/com/MetaPattern/MDA/Designer/DesignerExtendService';
import { ProductComponent } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { APPComponent } from '@/api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { BEComponent } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { DBComponent } from '@/api/com/MetaPattern/MDA/MD/DBModel/DBComponent';

@Component({
  components: {
    ToolBox
  }
})
export default class MDExplorer extends Vue {
  filterText = '';
  filterNode(value: any, data: any) {
    if (!value) return true;
    return data.label.toUpperCase().indexOf(value.toUpperCase()) !== -1;
  }

  @Watch('filterText')
  filter(val: string) {
    (this.$refs.tree as Tree).filter(val);
  }

  get defaultProps() {
    return {
      children: 'children',
      label: 'label',
      id: 'id',
      isLeaf: 'isLeaf'
    };
  }

  get treeData() {
    const apps = this.$store.state.ModuleMD.apps as Array<APP>;
    const appTrees = new Array<TreeNode<BaseElement>>();
    apps.forEach(app => {
      const tree = new TreeNode<BaseElement>(app.designId, `${app.name}(${app.displayName})`, app.designId, false, app);
      app.aPPComponents.forEach(appComponent => {
        const beCom = new TreeNode<BaseElement>(appComponent.designId, appComponent.rootNamespace, appComponent.designId, false, appComponent);
        tree.addChild(beCom);
      });
      app.bEComponents.forEach(be => {
        const beCom = new TreeNode<BaseElement>(be.designId, be.rootNamespace, be.designId, false, be);
        tree.addChild(beCom);
      });
      app.uIModelComponents.forEach(uiModel => {
        const uiModelCom = new TreeNode<BaseElement>(uiModel.designId, uiModel.rootNamespace, uiModel.designId, false, uiModel);
        tree.addChild(uiModelCom);
      });
      appTrees.push(tree);
    });
    return appTrees;
  }

  async getComponentTrees(designId: string, componentType: EnumComponentType): Promise<Array<TreeNode<BaseElement>>> {
    // TODO : ModuleMD中elements的component，是获取应用的时候放入的，没有旗下的实体等信息。在打开模型的时候，应该要更新下面的内容
    let trees: Array<TreeNode<BaseElement>> = null;
    const diagram = this.$store.state.ModuleMD.diagrams.find((item: Diagram) => item.component.designId === designId);
    let component: BaseComponent;
    if (diagram && diagram.component !== null) {
      component = diagram.component;
      trees = MDExtendService.buildComponentTree(component);
    } else {
      return new Promise((resolve, reject) => {
        Diagram.loadAsync(designId, componentType)
          .then((response: Diagram) => {
            this.$store.dispatch('ModuleMD/setDiagramAction', response);
            trees = MDExtendService.buildComponentTree(response.component);
            resolve(trees);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    }
    return new Promise((resolve) => resolve(trees));
  }

  async getUIModelComponentTrees(designId: string): Promise<Array<TreeNode<BaseElement>>> {
    let trees: Array<TreeNode<BaseElement>> = null;
    const findComponent = this.$store.state.ModuleMD.uiModelComponents.find((item: UIModelComponent) => item.designId === designId);
    let component: BaseComponent;
    if (findComponent) {
      component = findComponent;
      trees = MDExtendService.buildComponentTree(component);
    } else {
      return new Promise((resolve, reject) => {
        MDExtendService.GetFullComponentAsync(designId, EnumComponentType.UIModel)
          .then((response: BaseComponent) => {
            this.$store.dispatch('ModuleMD/setUIModelComponentAction', response);
            trees = MDExtendService.buildComponentTree(response);
            resolve(trees);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    }
    return new Promise((resolve) => resolve(trees));
  }

  loadNode(node: any, resolve: any) {
    if (node.level === 0) {
      return resolve(this.treeData);
    }

    if (node.level === 1) {
      return resolve(node.data.children);
    }

    if (node.level === 2) {
      if (node.data.data.componentType === EnumComponentType.UIModel) {
        this.getUIModelComponentTrees(node.data.id)
          .then((trees) => {
            if (trees !== null) {
              resolve(trees);
            }
          });
      } else {
        this.getComponentTrees(node.data.id, node.data.data.componentType)
          .then((trees) => {
            if (trees !== null) {
              resolve(trees);
            }
          });
      }
    } else {
      return resolve(node.data.children);
    }
  }

  /** 处理拖拽事件，将拖拽的元数据及类型放入事件中传输 */
  handleDragStart(node: any, evt: any) {
    const element = node.data.data;
    if (element) {
      evt.dataTransfer.setData('elementId', node.data.data.designId);
      evt.dataTransfer.setData('type', this.getType(node));
    }
  }

  /** 获取可拖拽节点的元素类型，不可拖拽则返回空字符串 */
  getType(node: any) {
    let type = '';
    const element = node.data.data;
    if (element) {
      if (element instanceof APP) {
        type = MDAConstant.Type.ADD_APP; // 应用，建立产品应用
      } else if (element instanceof BEEntity) {
        type = MDAConstant.Type.ADD_ENTITY; // 实体，建立引用实体
      // } else if (element instanceof BEService) {
      //   type = MDAConstant.Type.ADD_SERVICE; // 服务，建立外部服务（每个Action都自动建立）
      } else if (element instanceof BEServiceAction) {
        type = MDAConstant.Type.ADD_SERVICEACTION; // 服务操作，建立外部服务
      }
    }
    return type;
  }

  getTypeIcon(node: any) {
    let typeName = '';
    const element = node.data.data;
    if (element) {
      if (element instanceof APP) {
        typeName = MDAConstant.Type.ADD_APP;
      } else if (element instanceof ProductComponent) {
        typeName = MDAConstant.Type.ADD_PRODUCTCOMPONENT;
      } else if (element instanceof APPComponent) {
        typeName = MDAConstant.Type.ADD_APPCOMPONENT;
      } else if (element instanceof BEComponent) {
        typeName = MDAConstant.Type.ADD_BECOMPONENT;
      } else if (element instanceof DBComponent) {
        typeName = MDAConstant.Type.ADD_DBCOMPONENT;
      } else if (element instanceof UIModelComponent) {
        typeName = MDAConstant.Type.ADD_UIMODELCOMPONENT;
      } else if (element instanceof ProductComment) {
        typeName = MDAConstant.Type.ADD_PRODUCTCOMMENT;
      } else if (element instanceof APPComment) {
        typeName = MDAConstant.Type.ADD_APPCOMMENT;
      } else if (element instanceof BEComment) {
        typeName = MDAConstant.Type.ADD_BECOMMENT;
      } else if (element instanceof Product) {
        typeName = MDAConstant.Type.ADD_PRODUCT;
      } else if (element instanceof BEEnum) {
        typeName = MDAConstant.Type.ADD_ENUM;
      } else if (element instanceof BEBusinessLogic) {
        typeName = MDAConstant.Type.ADD_BUSINESSLOGIC;
      } else if (element instanceof BEDTO) {
        typeName = MDAConstant.Type.ADD_DTO;
      } else if (element instanceof BEValueObject) {
        typeName = MDAConstant.Type.ADD_VALUEOBJECT;
      } else if (element instanceof BEService) {
        typeName = MDAConstant.Type.ADD_SERVICE;
      } else if (element instanceof BEServiceAction) {
        typeName = MDAConstant.Type.ADD_SERVICEACTION;
      } else if (element instanceof BEConstant) {
        typeName = MDAConstant.Type.ADD_CONSTANT;
      } else if (element instanceof BEDistributedTransaction) {
        typeName = MDAConstant.Type.ADD_DISTRIBUTEDTRANSACTION;
      } else if (element instanceof BEExternalService) {
        typeName = MDAConstant.Type.ADD_EXTERNALSERVICE;
      } else if (element instanceof BEReferenceEntity) {
        typeName = MDAConstant.Type.ADD_REFERENCEENTITY;
      } else if (element instanceof EntityMethod) {
        typeName = ''; // MDAConstant.Type.ADD_METHOD;
      } else if (element instanceof MenuSet) {
        typeName = MDAConstant.Type.ADD_MENUSET;
      } else if (element instanceof ConfigGroup) {
        typeName = MDAConstant.Type.ADD_CONFIGGROUP;
      } else if (element instanceof ProductAPP) {
        typeName = MDAConstant.Type.ADD_PRODUCTAPP;
      } else if (element instanceof BEInterface) {
        typeName = MDAConstant.Type.ADD_INTERFACE;
      } else if (element instanceof BEEntity) {
        typeName = MDAConstant.Type.ADD_ENTITY;
      }
    }
    if (typeName !== '') {
      return DesignerExtendService.getTypeIcon(typeName);
    }
    return '';
  }

  allowDrag(node: any) {
    const type = this.getType(node);
    if (type === '') {
      return false;
    }
    return true;
  }

  allowDrop() {
    return false;
  }
}
